import { Tutorial } from '@app/components/Guide/types/guide.types'
import { fetchTutorialBySlug } from '@app/services/strapiServices'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { lazy } from 'react'
import { ShareButton } from '@app/components/Guide/ui/ShareButton'
import { GuideSection } from '@app/components/Guide/ui/GuideSection'

const UiMarkdown = lazy(() => import('@app/components/Atoms/UiMarkdown/UiMarkdown'))

export const TutorialPage = () => {
  const params = useParams()
  const { data, isLoading, error } = useQuery<Tutorial>({
    queryKey: ['tutorial-page', params.articleSlug],
    queryFn: () => fetchTutorialBySlug(params.articleSlug as string),
    enabled: !!params.articleSlug,
  })

  if (isLoading) return <div>Loading...</div>
  if (error) return <div>Error</div>

  const arcadeId = data?.arcadeLink?.substring(34)
  const embedSource = `https://demo.arcade.software/${arcadeId}?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true`

  return (
    <main className="flex min-h-[1000px] w-full flex-col items-center bg-background">
      <GuideSection>
        <div className="relative h-[580px] w-full overflow-hidden rounded-xl border border-border bg-card shadow-sm">
          <iframe
            src={embedSource}
            allowFullScreen
            title={data?.title}
            loading="lazy"
            allow="clipboard-write"
            className="absolute inset-0 h-full w-full border-0 [color-scheme:light]"
          />
        </div>
      </GuideSection>
      <GuideSection backgroundColor="transparent">
        <div className="flex flex-col items-start w-full gap-4 p-6 border shadow-sm rounded-xl border-border bg-card text-card-foreground sm:p-8">
          <div className="flex flex-col items-start justify-between w-full gap-4 sm:flex-row sm:items-center">
            <h1 className="text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
              {data?.title}
            </h1>

            <ShareButton />
          </div>

          <div className="max-w-3xl text-sm leading-7 text-muted-foreground">
            <UiMarkdown>{data?.summary ?? 'No summary'}</UiMarkdown>
          </div>
        </div>
      </GuideSection>
    </main>
  )
}
